import script from "./action-card-table-row.vue?vue&type=script&setup=true&lang=ts"
export * from "./action-card-table-row.vue?vue&type=script&setup=true&lang=ts"

import "./action-card-table-row.vue?vue&type=style&index=0&id=6ace1f68&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.28_typescript@5.9.3__webpack@5.105.4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ace1f68"]])

export default __exports__